import React, { useState } from 'react'
import { useNodeForIds } from '../../utility/TreeHelpers'
import { Box, MenuItem, Select } from '@mui/material'
import { LanguageCode, NodeLanguageAttributeParams } from './types'
import { availableLanguages, updateParamsForBranch } from './utility'
import LoadingButton from '@mui/lab/LoadingButton'
import { doUpdate } from '../nodeUpdates/utility'
import { useGetTreeById } from 'shared/hooks/trees/hooks'

export function NodeLanguageAttribute({
  treeId,
  versionId,
  branches,
}: NodeLanguageAttributeParams) {
  return branches.map(({ nodeId, languageCode }) => {
    return (
      <LanguageAttributeBranch
        key={nodeId}
        treeId={treeId}
        versionId={versionId}
        nodeId={nodeId}
        languageCode={languageCode}
      />
    )
  })
}

type LanguageAttributeBranchParams = {
  treeId: string
  versionId: string
  nodeId: string
  languageCode: LanguageCode
}

function LanguageAttributeBranch(params: LanguageAttributeBranchParams) {
  const { tree, resetTree } = useGetTreeById(params)
  const [updating, setUpdating] = useState(false)
  const node = useNodeForIds(params)

  if (!node || !tree) return null

  const { completed, toUpdate, different } = updateParamsForBranch({
    branch: node,
    language: params.languageCode,
    tree,
  })

  const doUpdates = async () => {
    setUpdating(true)
    await doUpdate(...toUpdate)
    resetTree?.()
    setUpdating(false)
  }

  return (
    <Box>
      <Box>
        {`${node.title}: ${params.languageCode}`}{' '}
        <LoadingButton
          disabled={!toUpdate.length}
          onClick={doUpdates}
          loading={updating}
        >
          Do It
        </LoadingButton>
      </Box>
      <Box padding="5px">
        <Box>{`To Update: ${toUpdate.length}`}</Box>
        <Box>{`Completed ${completed.length}`}</Box>
        {!!different && <Box>{`Different ${different}`}</Box>}
      </Box>
    </Box>
  )
}

export function NodeLanguageSelect({
  disabled,
  currentValue,
  onChange,
}: {
  disabled?: boolean
  currentValue: LanguageCode
  onChange: (c: LanguageCode) => void
}) {
  return (
    <Select
      disabled={disabled}
      value={currentValue}
      onChange={({ target }) => onChange(target.value as LanguageCode)}
    >
      {availableLanguages.map(({ code, label }) => {
        return (
          <MenuItem key={code} value={code}>
            {label}
          </MenuItem>
        )
      })}
    </Select>
  )
}
